export const categories = [
  {
    slug: "entertainment",
    name: "娱乐事件",
    desc: "艺人言行、合作变动与公开回应的时间线梳理。",
    icon: "ri-star-smile-line",
    count: 38,
  },
  {
    slug: "livestream",
    name: "直播风波",
    desc: "直播间口误、分成、售后与承诺前后不一致的证据归档。",
    icon: "ri-live-line",
    count: 27,
  },
  {
    slug: "brand",
    name: "品牌代言",
    desc: "代言口径、物料调整与解约声明的截图对比。",
    icon: "ri-shield-star-line",
    count: 21,
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "舞台音频、现场录屏与官方物料之间的差异整理。",
    icon: "ri-music-2-line",
    count: 16,
  },
  {
    slug: "film",
    name: "影视剧组",
    desc: "通告单、改档与片场传闻的可核对素材。",
    icon: "ri-clapperboard-line",
    count: 14,
  },
  {
    slug: "dispute",
    name: "网络争议",
    desc: "搬运、版权与评论区论战的原始证据留存。",
    icon: "ri-chat-3-line",
    count: 10,
  },
];